export default {

    isEmpty(array){
        return array === undefined || array === null || array.length < 1;
    }

}
